import React from 'react';
import { Scan } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * PageHeader — header reutilizable para todas las páginas secundarias.
 * El logo navega siempre a "/" y el botón "← Volver" usa onBack si se pasa.
 */
export default function PageHeader({ onBack, backLabel = 'Volver' }) {
  const navigate = useNavigate();

  const goHome = () => navigate('/');

  return (
    <header className="sticky top-0 z-40 border-b border-zinc-800 bg-zinc-950/95 backdrop-blur-xl">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-3 sm:gap-4">
        {onBack && (
          <button
            onClick={onBack}
            className="text-zinc-400 hover:text-white transition-colors font-mono text-xs sm:text-sm flex-shrink-0 flex items-center gap-1"
          >
            ← <span className="hidden sm:inline">{backLabel}</span>
          </button>
        )}
        <button
          onClick={goHome}
          className="flex items-center gap-2 hover:opacity-80 transition-opacity flex-shrink-0"
          aria-label="Inicio"
        >
          <Scan className="w-6 h-6 sm:w-7 sm:h-7 text-blue-500" />
          <span className="font-heading text-lg sm:text-xl font-black tracking-tight">
            VERITAS <span className="text-blue-500">SCAN</span>
          </span>
        </button>
      </div>
    </header>
  );
}
